export interface ICheckboxOptions {
    customClass: string;
    title: string;
    id: string;
    labelText: string;
    checkboxCustomAttributes?: string;
    isReversed?: boolean;
    isRequired?: boolean;
    type?: string;
    inputName?: string;
    isRound?: boolean;
}

export const renderCheckbox = (options: ICheckboxOptions) => {
    let label = options.labelText;
    if (options.isRequired) {
        label += `<span class="error noTranslate">*</span>`;
    }
    let checkboxContainer = document.createElement("div");
    checkboxContainer.className = `drive-checkbox ${ options.customClass || "" }`;
    checkboxContainer.innerHTML = `
        <input
            class="drive-checkbox__input"
            type="${ options.type || "checkbox" }"
            id="checkbox_${ options.id }"
            ${ options.checkboxCustomAttributes || "" }
            name="${ options.inputName || "" }">
        <label class="drive-checkbox__label${ options.isReversed ? " reverse" : "" }" for="checkbox_${ options.id }">
            <div class="drive-checkbox__box${ options.isRound ? " circle" : "" }">
                <svg class="drive-checkbox__icon svgIcon" aria-hidden="true"><use xlink:href="#drive-check"></use></svg>
            </div>
            <div class="drive-checkbox__label-text">${ label || "" }</div>
        </label>`;
    return checkboxContainer;
};